
/**
 * Selection mode of smartTable
 */
export enum SELECTION_TYPE {

    /**
     * MULTIPLE_INTERVAL 
     * Select multiple intervals ( ex:[1-3, 5-8] ) or multiple values ( ex: [2,9,12] ) or intervals with values ( ex: [2,[4-6],[9-12],17,19] )
     * Shift: Select an interval
     * Ctrl: Select multiples values with ctrl handled
     */
    MULTIPLE_INTERVAL = 1,

    /**
     * MULTIPLE
     * Same as multiple MULTIPLE_INTERVAL, but ctrl is always enable 
     * Select multiple intervals ( ex:[1-3, 5-8] ) or multiple values ( ex: [2,9,12] ) or intervals with values ( ex: [2,[4-6],[9-12],17,19] )
     * Shift: Select an interval
     * Ctrl: Select multiples values - Always enable
     */
    MULTIPLE,

    /**
     * SINGLE_INTERVAL
     * Select single intervals ( ex:[3-8] ) or unique values ( ex: [4] )
     * Shift: Select an interval
     * Ctrl: No effect
     */
    SINGLE_INTERVAL,

    /**
     * SINGLE_INTERVAL
     * Select an unique value ( ex: [4] )
     * Shift: No effect
     * Ctrl: No effect
     */
    SINGLE
}
